import { Card, CardContent, CardMedia, Container, Stack, Typography, Rating, Avatar, Button, Box, FormControl, InputLabel, Input, FormHelperText, Snackbar, Alert } from "@mui/material";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import Grid from '@mui/material/GridLegacy'
import querybottom from '../assets/image/querybottom.png';
import queryemail from "../assets/image/queryemail.png"
import pratham from '../assets/image/query3.png';
import kenny from '../assets/image/query2.jpg';
import dev from "../assets/image/query1.png";
import { query } from "../services";
import Slider from "../component/slider";
const Query = () => {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    message: ''
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const MentosData = [
    {
      name: "Rajat",
      rate: '5',
      image: "",
      Desc: "GET Mentors is a student-to-student mentoring platform where you can connect with experienced students who’ve already studied abroad. They offer real, unbiased guidance based on their own journeys—without sales pitches or commissions.",
      exp: "What is GET Mentors?"
    },
    {
      name: "Mehak ",
      rate: '3',
      image: "",
      Desc: "Our mentors are verified students or recent graduates from top international universities. They’ve personally been through the admissions, visa, and relocation process and now guide others based on their lived experience.",
      exp: "Who are the mentors on this platform?"
    },
    {
      name: "David ",
      rate: '4',
      image: "",
      Desc: "Unlike agencies that often push universities they're partnered with, our mentors offer transparent, commission-free advice. You get insights that are experience-based, not sales-driven.",
      exp: " How is GET Mentors different from traditional study abroad agencies?"
    },
    {
      name: "Riya",
      rate: '3',
      image: "",
      Desc: "Yes, but only for the sessions you book. There are no hidden fees, and you're paying directly for a mentor's time—not a service commission or consulting package.",
      exp: " Do I need to pay for mentorship sessions?"
    },
    {

      Desc: "Absolutely! You can filter mentors by country, university, course, or even specific goals like scholarships, PR planning, or part-time work.",
      exp: "Can I choose a mentor based on the country or course I’m interested in?"
    },
    {
      Desc: "Simply browse through the mentor profiles, check their availability, and book a time slot that works for you. You’ll receive a confirmation and a meeting link for your session.",
      exp: "How do I book a session?"
    },
  ]
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration in milliseconds
      once: true, // Whether animation should happen only once
    });
  })
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value
    }));
  };
  const handleSubmit = async () => {

    try {
      const response = await query({
        email: formData.email,
        name: formData.name,
        message: formData.message,
      });

      if (response.status === 200) {
        setFormData({
          email: '',
          name: '',
          message: ''
        });
        setSnackbar({
          open: true,
          message: "Message Sent Successfully!",
          severity: "success",
        });

      }
    } catch (error) {
      console.error("Error:", error);
      setSnackbar({
        open: true,
        message: error?.response?.data?.message || "Login failed. Please try again.",
        severity: "error",
      });
    }
  };
  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <>
      {/* <Box

        sx={{
          width: "100%",
          height: { xs: "160px", sm: "250px", md: "355px", lg: "400px", xl: "680px" },
          overflow: "hidden",
          backgroundImage: `url(${querytop})`,  // ✅ Corrected syntax
          backgroundSize: "cover",         // Ensure image covers the whole area
          backgroundPosition: "center",     // Center the image
          display: "flex",                  // Use flex for positioning
          alignItems: "center",              // Center content vertically
          justifyContent: "start",          // Center content horizontally
          color: "white",                   // Adjust text color for visibility
          textAlign: "left",               // Center text
          // paddingL: "20px"                   // Add some padding
        }}
      >
        <Box sx={{
          width: {
            xs: "40%",
            sm: "40%",
            md: "40%",
            lg: "40%",
            xl: "40%",
          }, paddingLeft: { xs: "160px", sm: "175px", md: "196px", lg: "227px", xl: "390px" }
        }}>
          <motion.div
            initial={{ y: "-100vh", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.8, ease: "easeOut" }}
          >
            <Typography variant="h4" sx={{
              fontFamily: "Poppins, sans-serif", fontWeight: "600", lineHeight: "1.3", color: "#23a8e1", fontSize: {
                xs: "130px",
                sm: "1.7rem",
                md: "2.2rem",
                lg: "2.3rem",
                xl: "4rem"
              }
            }}>
              Feeling Stucks?
            </Typography>
            <Typography variant="h3" sx={{
              color: "#2B4F60", fontWeight: "500", fontSize: "3rem", fontFamily: "Poppins, sans-serif", fontSize: {
                xs: "130px",
                sm: "1.5rem",
                md: "2rem",
                lg: "3rem",
                xl: "4rem"
              }
            }}>Lets's Fix It Together !</Typography>
          </motion.div>
        </Box>
      </Box> */}
      <Grid container spacing={4} sx={{
        backgroundColor: "#93b1b5",
        overflow: "hidden",
        paddingTop: {
          xs: "100px", // For extra small screens
          sm: "120px", // Optional: for larger screens
        },
      }}>
        <Grid xs={12} sm={8} md={7} mt={4} mb={4}>
          <Box
            display="flex"
            height="100%"
            alignItems="center"
            justifyContent="center"
            sx={{
              minHeight: { xs: 'auto', sm: '300px' },
              px: { xs: 2, sm: 6 }, // horizontal padding
              textAlign: 'center',
            }}
          >
            <motion.div
              initial={{ y: "-100vh", opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{ duration: 1.8, ease: "easeOut" }}
              style={{ width: "100%" }} // ensure it wraps correctly
            >
              <Typography
                data-aos="fade-down"
                variant="h1"
                mb={4}
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 600,
                  lineHeight: 1.2,
                  fontSize: {
                    xs: "1.5rem",
                    sm: "2rem",
                    md: "2.2rem",
                    xl: "3.5rem",
                  },
                  paddingLeft: {
                    xs: "27px",


                  },
                  wordBreak: "break-word",
                }}
              >
                Have Questions? Get Real Answers
              </Typography>
              <Typography
                data-aos="fade-right"
                variant="h5"
                sx={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 700,
                  lineHeight: 1.6,
                  color: "grey",
                  fontSize: {
                    xs: "1rem",
                    sm: "1.1rem",
                    md: "1.3rem",
                    xl: "1.8rem",
                  },
                  paddingLeft: {
                    xs: "27px",
                  },
                  wordBreak: "break-word",
                  px: { xs: 2, sm: 2 },
                }}
              >
                Our experts are here to help.{" "}
                <Box
                  component="span"
                  sx={{
                    color: "#2B4F60",
                    fontWeight: 500,
                    fontSize: "inherit",
                    display: "inline",
                    whiteSpace: "normal",
                  }}
                >
                  Whether you're confused about your study options, application process,
                  or visa steps — ask anything. No bots, no fluff — just practical advice from
                  people who've been in your shoes.
                </Box>
              </Typography>
            </motion.div>
          </Box>
        </Grid>
        {/* Right Side: Slider with vertical spacing */}
        <Grid
          item
          xs={12}
          mt={7} mb={7}
          sm={4}
          md={4}
          sx={{
            pt: { xs: 2, sm: 4 }, // Top padding
            pb: { xs: 2, sm: 4 }, // Bottom padding
            marginRight: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            marginLeft: {
              xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            paddingLeft: {
              // xs: "15px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
            // paddingRight: "50px",
          }}
        >
          <Slider image1={dev} image2={kenny} image3={pratham} />
        </Grid>
      </Grid>
      <Container sx={{ marginTop: "50px" }}>
        <Grid container spacing={5} sx={{ textAlign: 'center', overflow: "hidden" }}>
          {/* Heading section */}
          <Grid
            container
            data-aos="fade-up"
            xs={12}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on larger screens
              justifyContent: "center",
              alignItems: "center",
              paddingTop: "70px",
              paddingX: { xs: "10px", sm: "20px", md: "30px" },
              textAlign: "center",
              flexWrap: "wrap",
              overflow: "hidden",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                color: "#2B4F60",
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
                fontSize: {
                  xs: "1.8rem",
                  sm: "2.2rem",
                  md: "2.8rem",
                  lg: "3rem",
                },
                marginRight: { xs: 0, sm: "5px" },
              }}
            >
              Frequently Asked
            </Typography>
            <Typography
              variant="h2"
              sx={{
                color: "#23a8e1",
                fontWeight: 500,
                fontFamily: "Poppins, sans-serif",
                fontSize: {
                  xs: "1.8rem",
                  sm: "2.2rem",
                  md: "2.8rem",
                  lg: "3rem",
                },
              }}
            >
              Questions
            </Typography>
          </Grid>

        </Grid>
        <Grid
          container
          spacing={6}
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
            marginBottom: "50px",
            overflow: "hidden",
          }}
        >
          {MentosData.map((item, index) => (
            <Grid
              item
              key={index}
              xs={12}
              sm={6}
              md={6}
              sx={{
                display: "flex", // allow card to stretch
                marginRight: {
                  xs: "15px",
                  sm: "0px",
                  md: "0px",
                  xl: "0px",
                  lg: "0px",
                },
              }}
            >
              <Card
                sx={{
                  padding: 2,
                  borderRadius: "30px",
                  backgroundColor: "aliceblue",
                  border: "2px solid #2B4F60",
                  boxShadow: "4px 4px 8px #2B4F60",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <CardContent sx={{ flexGrow: 1 }}>
                  <Stack sx={{ alignItems: "center" }} spacing={1}>
                    <Box>
                      <Typography
                        variant="body1"
                        pb="10px"
                        fontWeight="500"
                        color="#2B4F60"
                        fontFamily="Poppins, sans-serif"
                        textAlign="left"
                        p="5px"
                      >
                        {item.exp}?
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        fontWeight="400"
                        fontFamily="Poppins, sans-serif"
                        mb="10px"
                        textAlign="left"
                        p="5px"
                      >
                        {item.Desc}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Box sx={{ textAlign: "center", mt: 4 }}>
        {/* Red Text */}
        <Typography
          variant="h3" data-aos="fade-up"
          fontWeight="600"
          fontFamily="Poppins, sans-serif"
          mb="40px"
          color="#2B4F60"
          sx={{
            fontSize: {
              xs: "1.5rem", // Adjusted for extra small screens
              sm: "1.7rem",
              md: "2.2rem",
              lg: "3rem",
              xl: "4rem"
            }
          }}
        >
          Can’t find what you need? Drop us a message!
        </Typography>


        {/* Message Box */}

        <Container data-aos="fade-right"
          sx={{
            backgroundImage: `url(${querybottom})`,
            backgroundSize: "cover", // Ensures the image covers the entire container
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            minHeight: { xs: "300px", sm: "350px", md: "400px", lg: "450px" }, // Responsive height
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: { xs: 2, sm: 3, md: 4 }, // Adjust padding on smaller screens
            mb: "80px",
            mt: "30px",
            borderRadius: "30px",
          }}
        >

          <Card sx={{
            height: "400px", width: "70%", borderRadius: "15px", display: "flex", alignItems: "center", padding: 3, overflow: {
              xs: "auto", sm: "auto", md: "hidden"
            }
          }}>
            <Grid container spacing={3} alignItems="center" >

              {/* Left Side - Image */}
              <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
                <CardMedia
                  component="img"
                  image={queryemail}
                  sx={{
                    width: {
                      xs: "30%", sm: "20%", md: "60%"
                    }, height: "auto"
                  }}
                />
              </Grid>

              {/* Right Side - Form */}
              <Grid item xs={12} md={6} >
                <Typography
                  variant="h4"
                  color="#2B4F60"
                  fontFamily="Poppins, sans-serif"
                  fontWeight="500"
                >
                  Get In <span style={{ color: "#23a8e1" }}>Touch</span>
                </Typography>

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Email address</InputLabel>
                  <Input
                    id="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    aria-describedby="email-helper-text"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Name</InputLabel>
                  <Input
                    id="name"
                    value={formData.name}
                    onChange={handleInputChange}
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 2 }}>
                  <InputLabel>Message</InputLabel>
                  <Input
                    id="message"
                    multiline
                    rows={3}
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </FormControl>


                <Button onClick={handleSubmit} variant="contained" color="primary" fullWidth>Send Message</Button>
              </Grid>

            </Grid>
          </Card>
        </Container>


      </Box>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>

  )
}

export default Query;